"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postHogService = void 0;
const posthog_js_1 = __importDefault(require("posthog-js"));
const POSTHOG_HOST = 'https://ph.omnito.ai/';
const POSTHOG_API_KEY = REACT_APP_POSTHOG_KEY;
class PostHogService {
    constructor() {
        Object.defineProperty(this, "initialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    initialize() {
        if (this.initialized)
            return;
        if (!POSTHOG_API_KEY) {
            console.warn('[PostHog] REACT_APP_POSTHOG_KEY is not set, skipping');
            return;
        }
        try {
            posthog_js_1.default.init(POSTHOG_API_KEY, {
                api_host: POSTHOG_HOST,
                person_profiles: 'always',
                capture_pageview: false,
                capture_pageleave: false,
            });
            this.initialized = true;
        }
        catch (error) {
            console.error('[PostHog] Initialization failed:', error);
        }
    }
    identify(email) {
        if (!this.initialized)
            return;
        posthog_js_1.default.identify(email, { email });
    }
    reset() {
        if (!this.initialized)
            return;
        posthog_js_1.default.reset();
    }
    capture(eventName, properties) {
        if (!this.initialized)
            return;
        posthog_js_1.default.capture(eventName, properties);
    }
    setOnce(properties) {
        if (!this.initialized)
            return;
        posthog_js_1.default.people.set_once(properties);
    }
}
exports.postHogService = new PostHogService();
